const t = () => ({
  componentType: "default"
});
export {
  t as default
};
//# sourceMappingURL=defaultTransformer.js.map
